import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import SortIcon from "../../../global/components/SortIcon";
import { formatUTCTimeWithSec } from "../../../global/utils/unixToLocalTime";
import { plateAccessTypeOptions } from "../../../utils/Common";

function formatCallDuration(seconds) {
  const total = Number(seconds);
  if (!Number.isFinite(total) || total < 0) return "";
  const mins = Math.floor(total / 60);
  const secs = Math.floor(total % 60);
  if (mins <= 0) return `${secs}s`;
  return `${mins}m ${secs}s`;
}

function accessTypeLabel(value) {
  if (value == null || value === "") return "";
  const match = plateAccessTypeOptions.find(
    (opt) => Number(opt.value) === Number(value),
  );
  return match?.label ?? String(value);
}

function AccessResultCell({ record }) {
  const granted = Number(record?.AccessGranted) === 1;
  const denied = Number(record?.AccessGranted) === 0;

  if (granted) {
    return (
      <div className="flex items-center gap-1.5 text-[#389e0d]">
        <CheckCircleFilled className="text-[14px]" />
        <span>Granted</span>
      </div>
    );
  }

  if (denied) {
    return (
      <div className="flex items-center gap-1.5 text-[#cf1322]">
        <CloseCircleFilled className="text-[14px]" />
        <span>Denied</span>
      </div>
    );
  }

  return <div>{record?.AccessGrantedLabel || ""}</div>;
}

function sortableHeader(modParams, setParams, columnKey) {
  return {
    sorter: () => {},
    sortIcon: () => (
      <SortIcon
        sortOrder={modParams.order}
        columnKey={columnKey}
        sortBy={modParams.sort_by}
      />
    ),
    onHeaderCell: () => ({
      onClick: () =>
        setParams({
          ...modParams,
          sort_by: columnKey,
          order:
            modParams.sort_by === columnKey && modParams.order === "desc"
              ? "asc"
              : "desc",
        }),
    }),
  };
}

export const CallHistoryColumns = (setParams, params) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};

  return [
    {
      title: "No",
      dataIndex: "CallLogNo",
      key: "CallLogNo",
      width: 80,
      ...sortableHeader(modParams, setParams, "CallLogNo"),
    },
    {
      title: "Time",
      dataIndex: "LogTime",
      key: "LogTime",
      width: 170,
      render: (text) => <div>{text ? formatUTCTimeWithSec(text) : ""}</div>,
      ...sortableHeader(modParams, setParams, "LogTime"),
    },
    {
      title: "Device Name",
      dataIndex: "DeviceName",
      key: "DeviceName",
      width: 150,
      ...sortableHeader(modParams, setParams, "DeviceName"),
    },
    {
      title: "Answered By",
      dataIndex: "PersonName",
      key: "PersonName",
      width: 150,
      ...sortableHeader(modParams, setParams, "PersonName"),
    },
    {
      title: "Access Type",
      dataIndex: "AccessType",
      key: "AccessType",
      width: 120,
      render: (value) => <div>{accessTypeLabel(value)}</div>,
      ...sortableHeader(modParams, setParams, "AccessType"),
    },
    {
      title: "Access Item",
      dataIndex: "AccessItemName",
      key: "AccessItemName",
      width: 160,
      ...sortableHeader(modParams, setParams, "AccessItemName"),
    },
    {
      title: "Access",
      dataIndex: "AccessGranted",
      key: "AccessGranted",
      width: 120,
      render: (_, record) => <AccessResultCell record={record} />,
      ...sortableHeader(modParams, setParams, "AccessGranted"),
    },
    {
      title: "Unlocked From",
      dataIndex: "ControlFromLabel",
      key: "ControlFrom",
      width: 150,
      render: (text, record) => (
        <div>
          {text ||
            (record?.ControlFrom === 1 ? "Directory" : "Virtual Intercom")}
        </div>
      ),
      ...sortableHeader(modParams, setParams, "ControlFrom"),
    },
    {
      title: "Call Duration",
      dataIndex: "CallDuration",
      key: "CallDuration",
      width: 120,
      render: (value) => <div>{formatCallDuration(value)}</div>,
      ...sortableHeader(modParams, setParams, "CallDuration"),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      width: 1,
    },
  ];
};
